<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addHqActivityDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" :disabled="editable" label-position="left" ref="addHqActivityFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="总部活动" prop="activityName">
            <el-input v-model="formData.activityName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="细分市场" prop="districtArea">
            <el-select v-model="formData.districtArea" placeholder="请选择" clearable>
              <el-option v-for="item in marketList" :key="item.id" :label="item.marketSegment" :value="item.marketSegment" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工具包链接">
            <el-input v-model="formData.sourceLink" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否批量审批" prop="isBatchApprove">
            <el-radio-group v-model="formData.isBatchApprove">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button :disabled="editable" type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
export default {
  data () {
    return {
      rules: {
        activityName: [
          { required: true, message: '请输入总部活动名称', trigger: 'blur' }
        ],
        districtArea: [
          { required: true, message: '请选择细分市场', trigger: 'change' }
        ],
        isBatchApprove: [
          { required: true, message: '请选择是否批量审批', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {
        isBatchApprove: '0'
      },
      marketList: []
    };
  },
  props: {
    addHqActivityVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    addHqActivityVisible (val) {
      if (val) {
        if (this.rowData.id) {
          let rowData = JSON.parse(JSON.stringify(this.rowData));
          rowData.isBatchApprove = `${this.rowData.isBatchApprove}`;
          this.formData = rowData;
        }
      } else {
        this.formData = {};
        this.$nextTick(() => {
          this.$refs.addHqActivityFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitHandlen () {
      this.$refs['addHqActivityFrom'].validate(valid => {
        if (valid) {
          let params = {
            activityName: this.formData.activityName,
            districtArea: this.formData.districtArea,
            dmCode: this.formData.dmCode,
            isBatchApprove: this.formData.isBatchApprove,
            sourceLink: this.formData.sourceLink
          };
          if (this.formData.id) {
            params.id = this.formData.id;
            this.$emit('editHqActivitySubHandle', params);
          } else {
            this.$emit('addHqActivitySubHandle', params);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    getMarketList () {
      newApplicationFormApi.getMarketList('000').then(res => {
        if (res.status === '200') {
          this.marketList = res.data;
        }
      });
    }
  },
  mounted () {
    this.getMarketList();
  }
};
</script>

<style scoped>

</style>
